/**
 * Shared vocabulary for the Add a message composer. Lives apart from
 * MessageTabs so that component file only exports a component (react-refresh).
 */
export type MessageTab = 'text' | 'voice' | 'video';

/** Display order — AC 1: Text, Voice, Video, left to right. */
export const MESSAGE_TABS: readonly MessageTab[] = ['text', 'voice', 'video'];

export const MESSAGE_TAB_LABEL: Record<MessageTab, string> = {
  text: 'Text',
  voice: 'Voice',
  video: 'Video',
};

export const messagePanelId = (tab: MessageTab) => `message-panel-${tab}`;

/** Tab id — the panel points back at it with aria-labelledby. */
export const messageTabId = (tab: MessageTab) => `message-tab-${tab}`;
